.mvButton {
    background-color: var(--bg-color);
    border-radius: 1.5rem;
    border: none;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
    text-align: center;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
    display: inline-block;
    font-size: 0.875rem;
    font-weight: 600;
    padding: 1em 1.75em;
    transition: 0.2s ease-in-out opacity, 0.2s ease-in-out background-color,
        0.2s ease-in-out color;
    opacity: 0.85;

    &:hover {
        opacity: 1;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
        pointer-events: none;
        text-decoration: none !important;
    }

    &.link {
        text-transform: none;
        text-decoration: underline;
        color: #14456b !important;

        &:hover {
            text-decoration: none;
        }
    }

    &.outline {
        background-color: #fff !important;
        color: var(--bg-color) !important;

        &:hover {
            background-color: var(--bg-color) !important;
            color: #ffffff !important;
        }
    }
}
